import React from 'react'
import { Chip, Typography, CircularProgress } from '@material-ui/core'
import PropTypes from 'prop-types'

export default function ActionChip({ handleClick, labelText, Icon, loading = false, disabled = false }) {
  return (
    <Chip
      icon={loading ? <CircularProgress color='secondary' size={20} /> : <Icon />}
      color='secondary'
      disabled={disabled}
      variant='outlined'
      label={<Typography variant='body2'>{labelText}</Typography>}
      onClick={handleClick}
    />
  )
}

ActionChip.propTypes = {
  handleClick: PropTypes.func.isRequired,
  labelText: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  Icon: PropTypes.elementType.isRequired
}
